import Hero from '../components/Hero';
import BrandValues from '../components/BrandValues';
import TrustSection from '../components/TrustSection';
import BrandStory from '../components/BrandStory';
import ProductShowcase from '../components/ProductShowcase';

export default function Home() {
  return (
    <main>
      <Hero />
      <BrandValues />
      <TrustSection />
      <BrandStory />
      <ProductShowcase />
    </main>
  );
}
